export default __webpack_public_path__ + "static/media/inlab.13bb78e6.svg";